export default __webpack_public_path__ + "assets/images/daff935fde33b5ee040449614e26fd85.svg";